import React from 'react';

export default function FwEditOutlineIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='far fa-edit' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
